<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="cms/static-page/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { StaticPage } from '@/modules/cms/data/static-page/create'
	import { StaticPageService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return StaticPage;
			},

			service()
			{
				return new StaticPageService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>